export const FormInput = ({ id, text, type, onChange, disabled, className, value, setValue }) => {
     //const [value, setValue] = useState(value); Estado para la cantidad

    function handleChange(e) {
        e.target.classList.remove("border-danger");
        /*if (setText !== undefined)
            setText(elem.options[elem.value].text)*/
        if (setValue !== undefined)
            setValue(e.target.value)
    }

    return (
        <div className={className}>
            <div class="mb-3">
                <label for={id} class="form-label letraDatos fw-bold">{text}</label>
                {/*<div id={props.idSeccion + "Helper"} class={"form-text textoErrores ms-1 " + (props.helper ? 'd-inline' : '')}>{props.helper}</div>*/}
                <input type={type} class={"form-control letraDatos"} disabled={disabled} id={id}  value={value}
                    onChange={handleChange} />{/*aria-describedby={props.idSeccion + "Helper"}*/}
            </div>
        </div>
    )
}